import React, { Component } from 'react';
import Slider from 'react-slick';
import StickyBox from 'react-sticky-box';
import {
  Section,
  Heading,
  Link,
  Paragraph,
  Icon,
  Button,
  AbsoluteCTA,
  BackgroundImage,
} from 'components';
import { ICON_TYPES } from 'config';
import { toHtml, getCloudinaryUrl } from 'config/helpers';
import { List, Perk, Step } from '..';
import { dataBenefits, dataOpportunities } from './logic.js';
import './JobOfferContent.scss';

class JobOfferContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      sliderSettings: {
        className: 'job-offer__mobile-slider',
        dotsClass: 'slick-dots slick-pagination',
        arrows: false,
        dots: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        adaptiveHeight: false,
        pauseOnHover: false,
        pauseOnDotsHover: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  }

  componentDidMount() {
    this.handleResize();

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };

  renderSlider(data, type) {
    const { sliderSettings } = this.state;
    const slides = [];

    switch (type) {
      case 'perks':
        const slidesNumber = data.length / 3;
        for (let i = 0; i < slidesNumber; i++) {
          const elements = i * 3;
          slides.push(
            <div className={'job-offer__slide'}>
              {data.slice(elements, elements + 3).map(item => (
                <Perk
                  key={item.id}
                  icon={item.icon}
                  title={item.title}
                  text={item.text}
                />
              ))}
            </div>,
          );
        }
        sliderSettings.infinite = true;
        break;
      case 'steps':
        data.map(item =>
          slides.push(
            <Step
              key={item.number}
              number={item.number}
              step={item.step}
              details={item.details}
            />,
          ),
        );
        sliderSettings.infinite = false;
        break;
      default:
        break;
    }

    return <Slider {...sliderSettings}>{slides}</Slider>;
  }

  renderItems = data =>
    data.map((item, index) => (
      <li key={index} className={'job-offer__role'}>
        {item.specific ? toHtml(item.specific) : ''}
      </li>
    ));

  renderPerks = data =>
    data.map(item => (
      <Perk
        key={item.id}
        icon={item.icon}
        title={item.title}
        text={item.text}
      />
    ));

  renderSteps = data =>
    data.map(item => (
      <Step
        key={item.number}
        number={item.number}
        step={item.step}
        details={item.details}
      />
    ));

  render() {
    const { isMobile } = this.state;
    const { data } = this.props;
    const { title, lead, mainContent, settings } = data;
    const apply = mainContent.apply ? mainContent.apply : '';

    return (
      <div className={'single-job-offer__container'}>
        <div className={'single-job-offer__container--mobile'}>
          <StickyBox bottom offsetBottom={0} style={{ zIndex: 100 }}>
            <Link
              to={apply}
              id={'contact-career-footer'}
              className={'job-offer__button--mobile apply-now-job-offer'}
            >
              <Button id={'contact-career-footer-button'} color={'black'}>
                Apply now
              </Button>
            </Link>
          </StickyBox>

          <Section additionalClass={'job-offer__section--first'} spaceless>
            <div className={'job-offer__title'}>
              <div className={'job-offer__position'}>
                <Heading size={'large'} type={1}>
                  {mainContent.name ? mainContent.name : ''}
                </Heading>
              </div>
              <div className={'job-offer__underline'} />
            </div>
            <div className={'job-offer__title'}>
              <Heading size={'regular'} type={2}>
                {mainContent.city ? mainContent.city : ''}
              </Heading>
              <Heading size={'regular'} type={3}>
                {mainContent.salary ? mainContent.salary : ''}
              </Heading>
              {mainContent.salary2ndLine && (
                <Heading size={'regular'} type={3}>
                  {mainContent.salary2ndLine ? mainContent.salary2ndLine : ''}
                </Heading>
              )}
            </div>
            {lead && (
              <div className={'job-offer__subtitle'}>
                {toHtml(lead)}
                <Link
                  to={'/career/'}
                  id={'return-to-career'}
                  additionalClass={'job-offer__link job-offer--desktop'}
                >
                  <Icon
                    icon={ICON_TYPES.RIGHT_ARROW}
                    size={'medium'}
                    color={'pigeon-post'}
                  />
                  <Paragraph color={'white'} additionalClass={'text--bold'}>
                    Career
                  </Paragraph>
                </Link>
              </div>
            )}
          </Section>

          <BackgroundImage
            src={getCloudinaryUrl(mainContent.banner, 'f_auto,q_auto,w_1920')}
            additionalClass={'job-offer__image'}
          />

          <div className={'job-offer__container'}>
            <div className={'job-offer__sticky-container'}>
              <StickyBox offsetTop={200} offsetBottom={200}>
                <div className={'job-offer__sticky-box'}>
                  <Heading size={'medium-plus'} type={3}>
                    {mainContent.name ? mainContent.name : ''}
                  </Heading>
                  <div className={'job-offer__underline--small'} />
                  <Link
                    to={apply}
                    id={'contact-career-sticky-box'}
                    className={'job-offer--desktop apply-now-job-offer'}
                  >
                    <Button
                      id={'contact-career-footer-button'}
                      color={'black'}
                    >
                      Apply now
                    </Button>
                  </Link>
                </div>
              </StickyBox>
            </div>
            <Section additionalClass="job-offer__section--second">
              <div className={'job-offer__heading'}>
                <Heading size={'big'} type={2}>
                  What do you need to get this position?
                </Heading>
                <div
                  className={
                    'job-offer__underline job-offer__underline--short'
                  }
                />
              </div>
              <div className={'job-offer__requirements'}>
                {mainContent.technical ? (
                  <List data={mainContent.technical} title={'Technically'} />
                ) : (
                  <div />
                )}
                {mainContent.additional ? (
                  <List
                    data={mainContent.additional}
                    title={'Nice-to-haves'}
                  />
                ) : (
                  <div />
                )}
                <div className={'job-offer__button'}>
                  <Heading size={'regular'} type={2}>
                    {mainContent.name ? mainContent.name : ''}
                  </Heading>
                  <div className={'job-offer__underline--small'} />
                  <Link
                    to={apply}
                    id={'contact-career'}
                    className={'apply-now-job-offer'}
                  >
                    <Button id={'contact-career-button'} color={'black'}>
                      Apply now
                    </Button>
                  </Link>
                </div>
              </div>
            </Section>
            <Section additionalClass={'job-offer__section--third'}>
              <div className={'job-offer__heading'}>
                <Heading size={'big'} type={2}>
                  Joining us as a {mainContent.name ? mainContent.name : ''}{' '}
                  means...
                </Heading>
                <div
                  className={
                    'job-offer__underline job-offer__underline--short'
                  }
                />
              </div>
              <div className={'job-offer__roles'}>
                <ul>
                  {mainContent.specifics
                    ? this.renderItems(mainContent.specifics)
                    : ''}
                </ul>
              </div>
            </Section>
          </div>

          <Section
            additionalClass={'job-offer__section--cta'}
            fullwidth
            spaceless
          >
            <AbsoluteCTA
              additionalClass={'job-offer__cta'}
              link={apply}
              linkID={'career-job-offer'}
              linkText={'apply!'}
              description={'Feels like your place-to-be? Keep reading and'}
              underlineColor={'yellow'}
              backgroundColor={'pigeon-post'}
            />
          </Section>
          <div className={'job-offer--desktop'}>
            <BackgroundImage
              src={
                mainContent.photo
                  ? getCloudinaryUrl(mainContent.photo, 'f_auto,q_auto,w_1920')
                  : ''
              }
              additionalClass={'job-offer__image'}
            />
          </div>

          <div className={'job-offer__container job-offer__container--mobile'}>
            <div className={'job-offer__sticky-container'}>
              <StickyBox offsetTop={200} offsetBottom={200}>
                <div className={'job-offer__sticky-box'}>
                  <Heading size={'medium-plus'} type={3}>
                    {mainContent.name ? mainContent.name : ''}
                  </Heading>
                  <div className={'job-offer__underline--small'} />
                  <Link
                    to={apply}
                    id={'contact-career-sticky-box'}
                    className={'job-offer--desktop apply-now-job-offer'}
                  >
                    <Button
                      id={'contact-career-footer-button'}
                      color={'black'}
                    >
                      Apply now
                    </Button>
                  </Link>
                </div>
              </StickyBox>
            </div>
            <Section additionalClass="job-offer__section--fourth">
              <div className={'job-offer__heading'}>
                <Heading size={'big'} type={2}>
                  Development
                  <br />
                  opportunities
                </Heading>
                <div
                  className={
                    'job-offer__underline job-offer__underline--short'
                  }
                />
              </div>
              <div className={'job-offer__perks'}>
                {isMobile ? (
                  <div className={'job-offer__carousel'}>
                    {this.renderSlider(dataOpportunities, 'perks')}
                  </div>
                ) : (
                  <div className={'job-offer__perks--flex'}>
                    {this.renderPerks(dataOpportunities)}
                  </div>
                )}
              </div>
            </Section>
            <Section additionalClass="job-offer__section--fifth job-offer--desktop">
              <div className={'job-offer__heading'}>
                <Heading size={'big'} type={2}>
                  Perks
                  <br />
                  &amp; benefits
                </Heading>
                <div
                  className={
                    'job-offer__underline job-offer__underline--short'
                  }
                />
              </div>
              <div className={'job-offer__perks job-offer__perks--flex'}>
                {this.renderPerks(dataBenefits)}
              </div>
            </Section>
            <Section additionalClass="job-offer__section--sixth">
              <div className={'job-offer__heading'}>
                <Heading size={'big'} type={2}>
                  How to get
                  <br />
                  on board
                </Heading>
                <div
                  className={
                    'job-offer__underline job-offer__underline--short'
                  }
                />
              </div>
              {isMobile ? (
                this.renderSlider(mainContent.steps, 'steps')
              ) : (
                <div className={'job-offer__steps'}>
                  {mainContent.steps
                    ? this.renderSteps(mainContent.steps)
                    : ''}
                </div>
              )}
            </Section>
          </div>
        </div>
        <Section additionalClass="job-offer__section--seventh">
          <div className={'job-offer__contact'}>
            <Heading size={'big'} type={2}>
              Ready to join?
            </Heading>
            <div className={'job-offer__underline--small'} />
            <Link
              to={apply}
              id={'contact-career-footer'}
              className={'apply-now-job-offer'}
            >
              <Button id={'contact-career-footer-button'} color={'black'}>
                Apply now
              </Button>
            </Link>
          </div>
        </Section>
      </div>
    );
  }
}

export default JobOfferContent;
